import * as React from 'react'

export const StagePodcast = props => (
  <svg
    width={72}
    height={81}
    viewBox="0 0 72 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_81_12635)">
      <path
        d="M33.1674 8.66097C34.9165 7.63532 37.0835 7.63532 38.8326 8.66097L60.9454 21.6273C62.6597 22.6325 63.7128 24.4708 63.7128 26.458V52.542C63.7128 54.5292 62.6597 56.3675 60.9454 57.3727L38.8326 70.339C37.0835 71.3647 34.9165 71.3647 33.1674 70.339L11.0546 57.3727C9.34033 56.3675 8.28719 54.5292 8.28719 52.542V26.458C8.28719 24.4708 9.34033 22.6325 11.0546 21.6273L33.1674 8.66097Z"
        fill="#FBFBFB"
      />
      <path
        d="M33.1902 15.6192C34.9278 14.6112 37.0722 14.6112 38.8099 15.6192L55.5006 25.3009C57.2277 26.3027 58.2908 28.1483 58.2908 30.1449V49.554C58.2908 51.5506 57.2277 53.3962 55.5006 54.398L38.8099 64.0798C37.0722 65.0877 34.9278 65.0877 33.1902 64.0798L16.4994 54.398C14.7723 53.3962 13.7093 51.5506 13.7093 49.554V30.1449C13.7093 28.1483 14.7723 26.3027 16.4994 25.3009L33.1902 15.6192Z"
        fill="#428456"
      />
      <path
        d="M46.3877 39.9493C47.0934 39.9493 47.6726 40.5265 47.5979 41.2315C47.1085 45.8534 44.0034 49.6897 39.7981 51.2181C38.4867 51.6947 37.4437 52.8485 37.4436 54.2496V55.3543C37.4436 56.2994 36.681 57.0655 35.7404 57.0655C34.7998 57.0655 34.0372 56.2994 34.0372 55.3543V54.2496C34.0371 52.8486 32.994 51.6947 31.6828 51.2181C27.4774 49.6897 24.3714 45.8535 23.8819 41.2315C23.8073 40.5267 24.3867 39.9495 25.0921 39.9493C25.7977 39.9493 26.3605 40.5272 26.4557 41.2296C27.0774 45.8232 30.9978 49.3635 35.7404 49.3635C40.483 49.3635 44.4024 45.8231 45.0242 41.2296C45.1193 40.5272 45.6823 39.9495 46.3877 39.9493Z"
        fill="white"
      />
      <path
        d="M35.8016 23.9739C39.6434 23.974 42.7581 27.1032 42.7581 30.9631V39.9493C42.7581 43.8093 39.6434 46.9384 35.8016 46.9385C31.9596 46.9385 28.845 43.8094 28.845 39.9493C28.845 39.3979 29.29 38.9508 29.8388 38.9508H34.8078C35.3565 38.9507 35.8016 38.5037 35.8016 37.9524C35.8016 37.401 35.3565 36.9541 34.8078 36.9539H29.8388C29.29 36.9539 28.845 36.5069 28.845 35.9554C28.845 35.404 29.29 34.957 29.8388 34.957H34.8078C35.3565 34.9568 35.8016 34.5099 35.8016 33.9585C35.8016 33.4072 35.3565 32.9602 34.8078 32.9601H29.8388C29.29 32.9601 28.845 32.513 28.845 31.9616C28.845 31.4102 29.29 30.9631 29.8388 30.9631H34.8078C35.3565 30.963 35.8016 30.516 35.8016 29.9647C35.8016 29.4133 35.3565 28.9664 34.8078 28.9662H30.4667C29.802 28.9662 29.3271 28.3196 29.635 27.7279C30.7967 25.4969 33.1218 23.9739 35.8016 23.9739Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_81_12635"
        x="-4"
        y="0"
        width="80"
        height="81"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.197115 0 0 0 0 0.00379068 0 0 0 0 0.119786 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12635"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12635"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
